
module.filter('options', function(ModelConfig, BasicOptions) {
    return function(nameOrValue, name) {
        var optionsName = name || nameOrValue,
            options;

        if (angular.isDefined(BasicOptions[optionsName])) {
            options = BasicOptions[optionsName];
        } else {
            options = ModelConfig.getOptions(optionsName);
        }

        if (angular.isDefined(name)) {
            return options && options.labels[options.index[nameOrValue]];
        } else {
            return options;
        }
    }
});


module.filter('label', function(ModelConfig) {
    return function(name, model) {
        return name && ModelConfig.getLabel(name, model);
    }
});

module.filter('question', function(ModelConfig) {
    return function(name, model) {
        return name && ModelConfig.getQuestion(name, model);
    }
});

module.filter('hasHelpText', function(ModelConfig) {
    return function(name, model) {
        return name && ModelConfig.hasHelpText(name, model);
    }
});

module.filter('helpText', function(ModelConfig) {
    return function(name, model) {
        return name && ModelConfig.getHelpText(name, model);
    }
});

module.directive('lookup', function() {
    return {
        restrict: 'E',
        template: "{{ (value | options:(name || bindName)) || default }}",
        scope: {value: '=', name: '@', default: '@'},
        link: function(scope, element, attrs) {
            var split = attrs.value.split('.');
            scope.bindName = split[split.length-1];
        }
    };
});
